export interface TransactionRef {
  id: number;
}

export interface ProductRef {
  code: string;
}

export interface WarehouseEntryView {
}

export interface SchoolRef {
  id: number;
}

export interface IdMapping {
  mappedId: string;
}

export interface CheckoutEntry {
  product: IdMapping;
  amount: number;
  itemPrice: number;
  currency: string;
  description?: string;
}

export interface SchoolCheckoutRequestInput {
  school: SchoolRef;
  entries: CheckoutEntry[];
}

export enum TransactionStatus {
  UNDER_EDIT = 'UNDER_EDIT',
  COMPUTED = 'COMPUTED',
  COMMITTED = 'COMMITTED',
  REMOVED = 'REMOVED',
}

export interface TransactionViewBase extends TransactionRef {
  processingDate: string;
  status: TransactionStatus;
}

export interface TransactionEntryBase {
  id: number;
  transactionEntryToCancelId?: number | null;
  canceledBy?: TransactionEntryBase | null;
  cancelled?: boolean | null;
}

export interface MappedProductTransactionEntry extends TransactionEntryBase {
  product: IdMapping;
  amount: number;
  itemPrice: number;
  currency: string;
  description?: string | null;
  cancelExpiryDate?: Date | null;
  expiryDate?: number | null;
}

export interface MappedProductWarehouseEntry extends WarehouseEntryView {
  product: IdMapping;
  amount: number;
}

export class SupportedSubs {
  static TeacherSub = SupportedSubs.createIdMapping("teacher-books-subscription")
  static All = [SupportedSubs.TeacherSub]

  static isSubscription(productCode: string) {
    return SupportedSubs.All.find(it => it.mappedId == productCode)
  }

  private static createIdMapping(mappedId: string) {
    let product = {} as IdMapping
    product.mappedId = mappedId
    return product
  }
}
